module.exports = __webpack_public_path__ + "img/SchlitzohrSpitzOhr.731c1b44.jpg";